// Ficha de producto (/product/:id) : galería, bloque de compra, upsell,
// accesorios, recuerdo y ficha técnica. Traducción de fr/fiche.js — mismas claves.
// Los textos de PRODUCTO (name, tagline, description, features) vienen de la
// base de datos vía la API : pasan por tp()/tpList(), nunca por estas claves.
// Tratamiento : «usted» (como el «vous» francés y el «u» neerlandés).
export default {
  'fiche.seo.titre': '{nom} — Joyful Reveal',
  'fiche.seo.descriptionDefaut':
    'El juego de gender reveal Joyful Reveal: un concurso por equipos, un puzle que montar entre todos y una pieza final rascable.',
  'fiche.seo.titreIntrouvable': 'Producto no encontrado',
  'fiche.seo.titreErreur': 'Error de carga',
  'fiche.seo.descriptionErreur': 'Este producto ya no está disponible en la tienda de Mirum Games.',

  'fiche.chargement.produit': 'Cargando el producto…',

  'fiche.erreur.introuvableTitre': 'Este pack ya no existe',
  'fiche.erreur.erreurTitre': 'No se ha podido cargar',
  'fiche.erreur.introuvableTexte':
    'Puede que lo hayamos sustituido. Encuentre todos nuestros packs en la tienda.',
  'fiche.erreur.erreurTexte':
    'Ha fallado la conexión con el servidor. Vuelva a intentarlo en un momento.',
  'fiche.erreur.versBoutique': '🛍️ Ver la tienda',

  'fiche.ariane.label': 'Ruta de navegación',

  'fiche.visuels.boiteAlt':
    'Parte delantera de la caja Joyful Reveal: dos ositos y la pieza de puzle rascable',
  'fiche.visuels.boiteLegende': 'La caja',
  'fiche.visuels.dosAlt':
    'Parte trasera de la caja: las 4 etapas del juego, los idiomas de las reglas y el código QR',
  'fiche.visuels.dosLegende': 'La parte trasera de la caja',
  'fiche.visuels.contenuAlt':
    'Contenido del Pack Premium: la caja, el cuestionario y las dos bolsitas de algodón',
  'fiche.visuels.contenuLegende': 'Esto es lo que recibe',
  'fiche.visuels.pochonsAlt': 'Las dos bolsitas de algodón que se entregan a los dos equipos',
  'fiche.visuels.pochonsLegende': 'Las bolsitas de equipo',
  'fiche.visuels.grattageAlt': 'Una mano rasca con una moneda la casilla dorada del puzle: aparece la palabra GIRL',
  'fiche.visuels.grattageLegende': 'El rascado',
  'fiche.visuels.puzzleEncadreAlt':
    'El puzle montado en un marco dorado, sobre un piano entre dos candeleros',
  'fiche.visuels.puzzleEncadreLegende': 'El recuerdo enmarcado',
  'fiche.visuels.puzzleTableAlt':
    'El puzle montado en su marco dorado, sobre una mesa de roble',
  'fiche.visuels.puzzleTableLegende': 'Después de la fiesta',
  'fiche.visuels.questionnaireAlt':
    'El cuestionario impreso en cartulina, con sus columnas Equipo 1, Equipo 2 y Padres',
  'fiche.visuels.questionnaireLegende': 'El cuestionario impreso',
  'fiche.visuels.voir': 'Ver: {legende}',

  'fiche.achat.gamme': 'Joyful Reveal — Ositos',
  'fiche.achat.promesse':
    'Once preguntas, dos equipos, una pieza para rascar — y todos lo descubren a la vez.',
  'fiche.achat.remise': '−{n} %',
  'fiche.achat.contenuTitre': 'Lo que incluye este pack',
  'fiche.achat.ajouter': '🛒 Añadir al carrito',
  'fiche.achat.indisponible': 'Temporalmente no disponible',
  'fiche.achat.reappro': 'Reposición en camino',
  'fiche.achat.expedition': '📦 Enviado desde Bélgica en 1 o 2 días laborables',
  // Debe seguir alineado con PAYS_LIVRES (frontend/src/lib/zonesLivraison.js).
  'fiche.achat.livraison':
    '🚚 Envío a Bélgica, Francia, Luxemburgo, Países Bajos, Alemania y España — gastos de envío calculados en el pago',
  'fiche.achat.langue':
    '🇫🇷 Caja y reglas en francés (resumen bilingüe francés / inglés en la caja)',
  'fiche.achat.retour': '↩️ 14 días para cambiar de opinión',

  'fiche.genre.titre': 'Es para…',
  'fiche.genre.fille': 'Niña',
  'fiche.genre.garcon': 'Niño',
  'fiche.genre.mixte': 'Niña + Niño',
  'fiche.genre.alerte': 'Elija primero niña o niño.',
  'fiche.genre.discretion':
    'Nadie más que usted lo sabrá: será la pieza rascable la que lo anuncie.',
  'fiche.genre.packMixte': '👫 Este pack incluye la versión niña Y la versión niño',
  'fiche.genre.packGarcon': '👦 Versión niño',
  'fiche.genre.packFille': '👧 Versión niña',

  // Frase en 4 segmentos porque dos pasajes van en negrita en el JSX :
  // « Por [X más], el [NOMBRE] añade los accesorios que… »
  'fiche.upsell.badge': '⭐ El más elegido',
  'fiche.upsell.phraseAvant': 'Por',
  'fiche.upsell.phraseGras': '{prix} más',
  'fiche.upsell.phraseMilieu': ', el',
  'fiche.upsell.phraseApres':
    'añade los accesorios que convierten el momento en una fiesta de verdad.',
  'fiche.upsell.voir': 'Ver el {nom} →',

  'fiche.caracteristiques.joueursLabel': 'Jugadores',
  'fiche.caracteristiques.joueursValeur': '2 a 10',
  'fiche.caracteristiques.dureeLabel': 'Duración',
  'fiche.caracteristiques.dureeValeur': '≈ 20 minutos',
  'fiche.caracteristiques.piecesLabel': 'Piezas',
  'fiche.caracteristiques.piecesValeur': '11 + 1 rascable',
  'fiche.caracteristiques.ageLabel': 'Edad',
  'fiche.caracteristiques.ageValeur': 'A partir de 3 años',

  'fiche.etapes.reglesLien': 'Leer las reglas completas',
  'fiche.etapes.reglesSuite': '— las 11 preguntas vienen incluidas, listas para imprimir.',

  'fiche.accessoires.titreAvec': '🎁 En este pack ya está todo preparado',
  'fiche.accessoires.titreSans': '🎁 ¿Quiere que todo esté listo al abrir la caja?',
  'fiche.accessoires.introAvec':
    'Abre la caja, pone el cuestionario sobre la mesa, cada equipo coge su bolsita — y empieza la partida.',
  'fiche.accessoires.introSans':
    'El Pack Premium añade los tres accesorios que marcan la diferencia el gran día:',
  'fiche.accessoires.photoContenuAlt':
    'El contenido del Pack Premium extendido: la caja, el cuestionario impreso y las dos bolsitas de equipo',
  'fiche.accessoires.photoContenuLegende':
    'El cuestionario impreso, la caja y las bolsitas — foto real',
  'fiche.accessoires.photoPochonsAlt':
    'Las dos bolsitas de algodón con cordón, etiquetadas Equipo 1 y Equipo 2',
  'fiche.accessoires.photoPochonsLegende': 'Las bolsitas de equipo de algodón — foto real',
  'fiche.accessoires.pochonsTitre': 'Dos bolsitas de algodón',
  'fiche.accessoires.pochonsTexte':
    'Etiquetadas Equipo 1 y Equipo 2: cada invitado elige su bando nada más llegar y la partida arranca sola.',
  'fiche.accessoires.questionnaireTitre': 'El cuestionario, ya impreso',
  'fiche.accessoires.questionnaireTexte':
    'Las 11 preguntas en cartón de 400 g, con las columnas de puntuación de los dos equipos — y una plantilla en blanco para escribir las suyas.',
  'fiche.accessoires.enveloppeTitre': 'El sobre de recuerdo',
  'fiche.accessoires.enveloppeTexte':
    'Después de la fiesta, el cuestionario relleno se guarda dentro — está pensado para pegarlo al dorso de un marco.',
  'fiche.accessoires.decouvrir': 'Descubrir el {nom} →',

  'fiche.souvenir.photoAlt':
    'El puzle terminado, enmarcado y colgado en la pared de una habitación de bebé',
  'fiche.souvenir.photoLegende': 'El puzle del gran día — 14 × 21 cm, el tamaño de un marco',
  'fiche.souvenir.surtitre': '¿Y después de la fiesta?',
  'fiche.souvenir.titre': 'Queda un cuadro',
  // Frase cortada alrededor del « 14 × 21 cm » en negrita (la medida no se traduce).
  'fiche.souvenir.tailleAvant': 'El puzle terminado mide',
  'fiche.souvenir.tailleApres':
    '— justo el tamaño de un marco de los que se venden en cualquier tienda. Muchos padres lo enmarcan y lo cuelgan en la habitación del bebé: el día en que todos se enteraron de la noticia, en una sola imagen.',
  // Frase cortada alrededor de « el sobre de recuerdo » en negrita.
  'fiche.souvenir.premiumAvant':
    'El cuestionario de este pack está pensado para eso: equipo ganador, quién rascó la pieza, la fecha — una vez relleno, deslícelo dentro del',
  'fiche.souvenir.premiumEnveloppe': 'sobre de recuerdo',
  'fiche.souvenir.premiumApres':
    ', pegado al dorso del marco. Dentro de diez años, ábranlo juntos.',
  'fiche.souvenir.upsell':
    'Con el Pack Premium, el cuestionario que rellenaron el gran día (equipo ganador, quién rascó, la fecha) se desliza dentro del sobre de recuerdo, al dorso del marco. Dentro de diez años, ábranlo juntos.',

  'fiche.specs.titre': '📋 Ficha técnica',
  'fiche.specs.contenuLabel': 'Contenido de la caja',
  'fiche.specs.contenuValeur': '11 piezas de puzle por ganar + 1 pieza única rascable',
  'fiche.specs.principeLabel': 'Concepto',
  'fiche.specs.principeValeur':
    'Concurso por equipos, puzle que montar y revelación final al rascar',
  'fiche.specs.reglesLabel': 'Reglas',
  'fiche.specs.reglesValeur':
    'Resumidas en el dorso de la caja, versión completa en línea mediante el código QR',
  'fiche.specs.matiereLabel': 'Material',
  'fiche.specs.matiereValeur': 'Cartón — caja y piezas',
  'fiche.specs.puzzleLabel': 'Puzle montado',
  'fiche.specs.puzzleValeur': '14 × 21 cm — el tamaño de un marco de tienda',
  'fiche.specs.securiteLabel': 'Seguridad',
  'fiche.specs.securiteValeur':
    'Conforme a CE / EN 71. Piezas pequeñas: no apto para menores de 3 años',
  'fiche.specs.origineLabel': 'Origen',
  'fiche.specs.origineValeur': 'Diseñado y enviado desde Bélgica por Mirum Games',
};
